<button type="button" class="pull-job br-interactive" (click)="toggle()" [attr.aria-expanded]="expanded" [attr.aria-controls]="'pull-results-' + job.jobId"
  [title]="job.source === 'google' ? 'Google Places' : 'OpenStreetMap'">
  <span class="pull-status-dot" aria-hidden="true"
    [class.pull-status-dot--done]="job.status === 'Completed'"
    [class.pull-status-dot--active]="active(job)"
    [class.pull-status-dot--failed]="job.status === 'Failed' || job.cellsFailed"></span>
  <span class="pull-job-body">
    <span class="pull-job-title" [class.br-text-muted]="!active(job) && (job.createsLeads ? job.leadsCreated === 0 : job.upserted === 0)">
      {{ job.createsLeads ? (job.leadsCreated | number) + ' new leads' : (job.upserted | number) + ' places' }}
    </span>
    <span class="pull-job-meta">
      {{ active(job) ? job.cellsDone + ' of ' + job.cellsTotal : job.cellsTotal }} grids<span *ngIf="!active(job)"> · {{ job.createdAt | date:'MMM d, HH:mm' }}</span><span *ngIf="job.leadsLinked"> · {{ job.leadsLinked }} linked</span>
      <span *ngIf="job.cellsFailed" class="br-text-danger"> · {{ job.cellsFailed }} failed</span>
    </span>
  </span>
  <span class="pull-job-status" [class.pull-job-status--active]="active(job)"
    [class.br-text-danger]="job.status === 'Failed'">{{ cancelRequested && active(job) ? 'Canceling' : job.status }}</span>
  <br-icon class="pull-chevron" aria-hidden="true">{{ expanded ? 'expand_less' : 'expand_more' }}</br-icon>
</button>

<progress *ngIf="active(job)" class="pull-progress" [value]="job.cellsDone" [max]="job.cellsTotal || 1" aria-label="Grids processed"></progress>
<section *ngIf="expanded" class="pull-job-results" [id]="'pull-results-' + job.jobId" aria-label="Pull results">
  <div class="pull-result-heading">
    <span class="br-small br-text-muted">{{ job.source === 'google' ? 'Google Places' : 'OpenStreetMap' }}</span>
    <button type="button" class="br-btn br-btn--ghost br-icon-btn" (click)="refreshResults()" aria-label="Refresh this pull's results" title="Refresh results"><br-icon>refresh</br-icon></button>
  </div>
  <p *ngIf="job.errorMessage" class="br-small br-text-danger">{{ job.errorMessage }}</p>
  <button *ngIf="active(job)" type="button" class="br-btn br-btn--outline-danger br-btn--sm br-mb-2"
    [disabled]="canceling || cancelRequested" (click)="cancel()">{{ cancelRequested ? 'Cancel requested…' : canceling ? 'Canceling…' : 'Cancel pull' }}</button>
  <p *ngIf="actionError" class="br-small br-text-danger" role="alert">{{ actionError }}</p>
  <div class="pull-content-switch">
    <div class="br-view-switch br-view-switch--quiet" role="group" aria-label="Task content">
      <button type="button" class="br-view" [class.br-view--on]="view === 'results'" [attr.aria-pressed]="view === 'results'"
              (click)="view = 'results'">{{ job.createsLeads ? 'Leads' : 'Places' }}</button>
      <button type="button" class="br-view" [class.br-view--on]="view === 'grids'" [attr.aria-pressed]="view === 'grids'"
              (click)="view = 'grids'">Grids</button>
      <button type="button" class="br-view" [class.br-view--on]="view === 'details'" [attr.aria-pressed]="view === 'details'"
              (click)="view = 'details'">Details</button>
    </div>
  </div>
  <ng-container *ngIf="view === 'results'">
    <p *ngIf="!job.recordsAvailable" class="br-small br-text-muted">This pull predates result tracking. Only summary counts are available.</p>
    <p *ngIf="job.recordsAvailable && !job.createsLeads" class="br-small br-text-muted">Older results may have no linked Lead. Pull again to create or link one.</p>
    <app-data-list *ngIf="job.recordsAvailable" #resultsList class="data-list--plain data-list--inline"
      [contextKey]="job.jobId + '-results'" [fetch]="fetchPlaces" [searchable]="false" [autoLoadMore]="false" [pageSize]="10" [trackByFn]="trackPlace"
      [emptyText]="active(job) ? 'Results will appear here as grids finish.' : 'No recorded results for this pull.'">
      <ng-template dataListItem let-row>
        <div class="pull-result">
          <div class="pull-place-heading">
            <button *ngIf="row.leadId != null" type="button" class="br-btn br-btn--link br-btn--sm pull-lead-name" (click)="focusLead(row)" title="Focus Lead on map">
              {{ row.leadName || row.name || ('Lead #' + row.leadId) }}
            </button>
            <strong *ngIf="row.leadId == null" class="pull-place-name">{{ row.name || ('Record #' + row.placeId) }}</strong>
            <span class="pull-place-outcome br-text-muted">{{ row.leadOutcome === 'Created' ? 'New' : row.leadOutcome === 'Linked' ? 'Linked' : row.leadOutcome === 'Existing' ? 'Existing' : row.outcome }}</span>
          </div>
          <div class="pull-place-meta">
            <span class="pull-place-location">
              <button *ngIf="row.leadId != null" type="button" class="br-btn br-btn--ghost br-icon-btn"
                      (click)="focusLead(row)" title="Show Lead on map"
                      [attr.aria-label]="'Show ' + (row.leadName || row.name || ('Lead #' + row.leadId)) + ' on map'">
                <br-icon>location_on</br-icon>
              </button>
              <span class="pull-place-address br-text-muted" [title]="row.address || ''">{{ row.address }}</span>
            </span>
            <button type="button" class="br-btn br-btn--link br-btn--sm pull-grid-link" (click)="focusGrid(row)" title="Grid: zoom / column / row">{{ row.zoom }}/{{ row.tileX }}/{{ row.tileY }}</button>
          </div>
        </div>
      </ng-template>
    </app-data-list>
  </ng-container>
  <section *ngIf="view === 'grids'" aria-label="Task grids">
    <p class="br-small br-text-muted br-mb-1">{{ job.cellsDone }}/{{ job.cellsTotal }} grids processed</p>
    <app-data-list #cellsList class="data-list--plain data-list--inline"
      [contextKey]="job.jobId + '-grids'" [fetch]="fetchCells" [searchable]="false" [autoLoadMore]="false" [pageSize]="10" [trackByFn]="trackCell" emptyText="No grids in this pull.">
          <ng-template dataListItem let-row>
            <div class="pull-result">
            <div class="br-flex br-flex-wrap br-items-center br-justify-between br-gap-2">
              <button type="button" class="br-btn br-btn--link br-btn--sm" (click)="focusGrid(row)" title="Grid: zoom / column / row"><br-icon>grid_on</br-icon>{{ row.zoom }}/{{ row.tileX }}/{{ row.tileY }}</button>
              <span class="br-badge">{{ row.status }}</span>
            </div>
            <p *ngIf="row.status === 'Completed'" class="br-small br-text-muted br-mb-0">{{ row.newPlaces }} new places · {{ row.updatedPlaces }} updated</p>
            <p *ngIf="row.errorMessage" class="br-small br-text-danger br-mb-0">{{ row.errorMessage }}</p>
            <p *ngIf="row.startedAt" class="br-small br-text-muted br-mb-0">Started {{ row.startedAt | date:'medium' }}</p>
            <p *ngIf="row.finishedAt" class="br-small br-text-muted br-mb-0">Finished {{ row.finishedAt | date:'medium' }}</p>
            </div>
          </ng-template>
    </app-data-list>
  </section>
  <section *ngIf="view === 'details'" class="br-small br-text-muted" aria-label="Task details">
    <dl class="pull-times">
      <dt>Task</dt><dd>{{ job.jobId }}</dd>
      <dt>Queued</dt><dd>{{ job.createdAt | date:'medium' }}</dd>
      <dt>Started</dt><dd>{{ job.startedAt ? (job.startedAt | date:'medium') : 'Waiting' }}</dd>
      <dt>Finished</dt><dd>{{ job.finishedAt ? (job.finishedAt | date:'medium') : '—' }}</dd>
      <dt>Place writes</dt><dd>{{ job.upserted | number }}</dd>
      <dt *ngIf="job.runningCost">Cost</dt><dd *ngIf="job.runningCost">{{ job.runningCost | currency:'USD' }}</dd>
    </dl>
  </section>
</section>
